module.exports = __webpack_public_path__ + "static/img/gongzhu.43af0848.jpg";